import { render, staticRenderFns } from "./ContainerInformeDescargas.vue?vue&type=template&id=dac0cdc6&"
import script from "./ContainerInformeDescargas.vue?vue&type=script&lang=ts&"
export * from "./ContainerInformeDescargas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dac0cdc6', component.options)
    } else {
      api.reload('dac0cdc6', component.options)
    }
    module.hot.accept("./ContainerInformeDescargas.vue?vue&type=template&id=dac0cdc6&", function () {
      api.rerender('dac0cdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/ContainerInformeDescargas/ContainerInformeDescargas.vue"
export default component.exports